import { callApi } from "@/api/apiInteraction";
import { ApiMethod } from "@/api/apiMethod";
import { getSpeckleProfile } from "@/services/equation-excel-client-metadata/equationExcelClientMetadata";
import type { VisibleExcelProfile } from "@/services/open-api/openApi.types";
import { appendQuery, constructUrl } from "@/utils/utils";

type SpeckleReceiveRequest = {
  speckle_receive_url: string;
  speckle_token: string;
};

export type SpeckleReceiveResponse = {
  obj: Record<string, unknown>;
  metadata: Record<string, unknown>;
};

export async function receiveSpeckleData(
  apiUrl: string,
  excelProfile: VisibleExcelProfile,
  speckleReceiveUrl: string,
  speckleToken: string
): Promise<SpeckleReceiveResponse> {
  const receiveEndpoint = getSpeckleProfile(excelProfile.profile)?.receive_speckle_endpoint;

  if (!receiveEndpoint) {
    throw new Error("Selected Excel profile does not define a Speckle receive endpoint.");
  }

  const url = appendQuery(constructUrl(apiUrl, receiveEndpoint), {
    desired_unit_system: "metric",
  });

  return await callApi<SpeckleReceiveResponse>(
    url,
    {
      speckle_receive_url: speckleReceiveUrl,
      speckle_token: speckleToken,
    } satisfies SpeckleReceiveRequest,
    ApiMethod.POST
  );
}
